import {
  IconClock,
  IconClockMinus,
  IconClockPlus,
  IconDatabase,
  IconDatabaseMinus,
  IconDatabasePlus,
  IconServer,
  IconTable,
  IconTableMinus,
  IconTablePlus,
} from '@tabler/icons-react';
import { calculateCollectionStatus } from 'lib/calculateCollectionStatus';
import type { Collection } from 'lib/models/collection';
import type { Database } from 'lib/models/database';

export default function entityIcon(
  ...[type, item]: [type: 'root', item: {}] | [type: 'db', item: Database] | [type: 'coll', item: Collection]
) {
  switch (type) {
    case 'root':
      return <IconServer />;

    case 'db': {
      const isDefined = item.collections.some((coll) => coll.isDefined);
      const collStatus = item.collections.filter((coll) => coll.isDefined).map((coll) => calculateCollectionStatus(coll));

      if (collStatus.some(({ hasMissing }) => hasMissing)) {
        return <IconDatabaseMinus color={isDefined ? 'var(--mantine-color-red-6)' : undefined} />;
      }
      if (collStatus.some(({ hasUndefined }) => hasUndefined)) {
        return <IconDatabasePlus color={isDefined ? 'var(--mantine-color-yellow-6)' : undefined} />;
      }
      return <IconDatabase />;
    }

    case 'coll': {
      const { hasMissing, hasUndefined } = calculateCollectionStatus(item);
      // timeseries collections get the clock family, with the same missing/undefined variants and colors as tables
      const isTimeseries = item.actual.some((actual) => !!actual.timeseries);
      const [Plain, Minus, Plus] = isTimeseries ? [IconClock, IconClockMinus, IconClockPlus] : [IconTable, IconTableMinus, IconTablePlus];

      if (hasMissing) {
        return <Minus color={item.isDefined ? 'var(--mantine-color-red-6)' : undefined} />;
      } else if (hasUndefined) {
        return <Plus color={item.isDefined ? 'var(--mantine-color-yellow-6)' : undefined} />;
      } else {
        return <Plain />;
      }
    }
  }
}
